export default __webpack_public_path__ + "static/image-5-724b73a52644e623678ec044fd954bc8.jpg";